<template>

    <div class="row--header" v-if="isDesktop">

      <div class="row__group row__group--main">
        <div class="row__label">
          <a href="javascript:void(0)">
            {{ $t('message.travels.overview.destination') }}
          </a>
        </div>
      </div>

      <div class="row__group row__group--secondary">
        <div class="row__item">
          <div class="row__label">
            <a href="javascript:void(0)">
              {{ $t('message.travels.overview.purpose') }}
            </a>
          </div>
        </div>
        <div class="row__item">
          <div class="row__label">
            <a href="javascript:void(0)">
              {{ $t('message.travels.overview.other') }}
            </a>
          </div>
        </div>
        <div class="row__item">
          <div class="row__label">
            <a href="javascript:void(0)">
              {{ $t('message.travels.overview.dateDeparture') }}
            </a>
          </div>
        </div>
        <div class="row__item">
          <div class="row__label">
            <a href="javascript:void(0)">
              {{ $t('message.travels.overview.dateReturn') }}
            </a>
          </div>
        </div>
        <div class="row__item">
          <div class="row__label">
            <a href="javascript:void(0)">
              {{ $t('message.travels.overview.status') }}
            </a>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import ElementRow from '@elements/ElementRow'
export default {
  name: 'travelsTableHeader',
  extends: ElementRow,
  components: {
  },
  props: {
    content: {
      type: Object,
      required: false
    },
    active: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice'
    }),
    isDesktop () {
      return this.device === 'desktop'
    }
  },
  watch: {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
